<template>
	<div class="sf-input-group-wrapper">
		<!--정비유형-->
		<span class="sf-input-group-wrapper__label">{{ getMessage_('QWCC001180') }}</span>
		<div class="search-option-wrapper__normal">
			<el-select v-model="data" @change="change">
				<!--전체-->
				<el-option :label="getMessage_('MWCC000753')" value=""></el-option>
				<el-option :key="index" v-for="(item, index) in ceqSearchTypeList" :label="item.commCdName" :value="item.commCd"></el-option>
			</el-select>
		</div>
	</div>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@mqy/ceqi/RoApcn/store/helpers';
export default {
	data() {
		return {
			data: null
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...serviceMethods,
		change(value) {
			this.setSearchParam_({ key: 'ceqType', value: value }).then(() => {
				this.$emit('reload', 1, 10);
			});
		},
		processInfo() {
			this.data = this.searchParams.ceqType;
		}
	},
	created() {
		if (this.searchParams.ceqType == null || this.searchParams.ceqType == '') this.searchParams.ceqType = '';
		this.data = this.searchParams.ceqType;
	}
};
</script>

<style></style>
